export const RequiredInformation = () => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-4">Required Information</h3>
      <div className="bg-accent/50 p-4 rounded-lg">
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li>The specific decision you need help with</li>
          <li>Customer pain points and goals</li>
          <li>Your goals and success metrics</li>
          <li>Options you're considering</li>
          <li>Timeline and any constraints</li>
        </ul>
      </div>
    </div>
  );
};